
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "@/components/ui/dropdown-menu";
import { ListingStatus } from "@/lib/types/adminTypes";

interface BulkActionsBarProps {
  selectedCount: number;
  onBulkStatusChange: (status: ListingStatus) => void;
  onBulkDelete: () => void;
}

export function BulkActionsBar({
  selectedCount,
  onBulkStatusChange,
  onBulkDelete
}: BulkActionsBarProps) {
  return (
    <div className="bg-muted p-3 rounded-md flex justify-between items-center">
      <span className="text-sm">{selectedCount} item(s) selected</span>
      <div className="flex gap-2">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="outline" size="sm">
              Change Status
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem onClick={() => onBulkStatusChange("published")}>
              Mark as Published
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => onBulkStatusChange("draft")}>
              Mark as Draft
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => onBulkStatusChange("archived")}>
              Archive Selected
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
        
        <Button 
          variant="destructive" 
          size="sm"
          onClick={onBulkDelete}
        >
          Delete Selected
        </Button>
      </div>
    </div>
  );
}
